export * from '@modules/label-glossary/Customer-glossary-definitions/opus-definitions';
export * from '@modules/label-glossary/Customer-glossary-definitions/prisme-definitions';
export * from '@modules/label-glossary/Customer-glossary-definitions/prisme-NY-definition';
export * from '@modules/label-glossary/Customer-glossary-definitions/øs-definitions';
